import { Component, OnInit } from '@angular/core';
import { LibraryService,MentorService,HrmsService,MasterService} from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-stuallot',
  templateUrl: './stuallot.component.html',
  styleUrls: ['./stuallot.component.scss'],
  providers:[LibraryService,MentorService,HrmsService,MasterService]
})
export class StuallotComponent implements OnInit {
  staffs=[];
  classes=[];
  stualloted=[];
  stuavailable=[];
  selstaff:any;
  selclass:any;
  closeResult: string='';
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  arrmentors: any=[];
  fmodel:any={};
  fmodel1:any={clid:'0',crid:'0',scid:'0'};
  arrcourse: any;
  sections: any;
  selectedItems:any=[];
  dropdownSettings:IDropdownSettings = {singleSelection: false,
        idField: 'stuid',
        textField: 'stunm',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 0,
        allowSearchFilter: true};
  constructor(private http: HttpClient,private hservice:HrmsService, private liservice: LibraryService,private mentservice: MentorService,private modalService: NgbModal,private mservice: MasterService) { }

  ngOnInit(): void {

    // this.getstaffdetails('selemp','');
    this.getmentors();
    this.mascourse();
    this.getstudentdata('sel_alloted', this.fmodel);
  }

  getmentors() {
    this.hservice.selmentoringstaff()
        .subscribe(
        resultArray => {
            console.log('getmentors', resultArray);
            this.arrmentors=resultArray;
            this.fmodel.emid=resultArray[0].emid;
            this.fmodel1.emid=resultArray[0].emid;
        },
        error => console.log("Error :: " + error)
      )}
    

 



  mascourse() {
        this.mservice.mascourse()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrcourse = resultArray;
                this.fmodel.crid=resultArray[0].crid;
                 this.fmodel1.crid=resultArray[0].crid;
                this.masclass();
                //this.fmodel1.crid=resultArray[0].crid;
            },
            error => console.log("Error :: " + error)
            )
      }

      masclass() {
      // this.mservice.classmasterrolewise(0,this.fmodel.crid,0,'class')
        this.mservice.masclass()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.classes = resultArray;
              this.fmodel.clid=resultArray[0].clid;
              this.fmodel1.clid=resultArray[0].clid;
              this.massection();
            //  this.masperiod();
              
             
          },
          error => console.log("Error :: " + error)
          )
    }

  massection() {
      // this.mservice.sectionsrolewise(0,this.fmodel.crid,this.fmodel.clid,'section')
       this.mservice.massection()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.sections = resultArray;
              this.fmodel.scid=resultArray[0].scid;
               this.fmodel1.scid=resultArray[0].scid;
             // this.masasshead();
             this.getstudentdata('sel_alloted', this.fmodel1);
          },
          error => console.log("Error :: " + error)
          )
    }

  getstudentdata(oprtype,obj) {
    this.mentservice.getstualloted(obj.emid,obj.clid,obj.scid,obj.crid,oprtype)
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
           //resultArray.splice(0,1);
           if (oprtype=='sel_alloted')
           {
            this.stualloted=resultArray;
           }
            else if(oprtype=='sel_nonalloted')
            {
              this.stuavailable=resultArray;

            }
            
        },
        error => console.log("Error :: " + error)
        )
  }


  allotstudent(obj,oprtype) {
    this.mentservice.deallocate(obj,oprtype)
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
            alert(resultArray.message);
            this.getstudentdata('sel_alloted', this.fmodel1);
           //resultArray.splice(0,1);
          //  this.getstudentdata('sel_nonalloted');
          //  this.getstudentdata('sel_alloted');
            
        },
        error => console.log("Error :: " + error)
        )
  }

  openinfo(content)
{
  // this.getstudentdata('sel_nonalloted');
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        
    });
}

  composefilterclass(jstring)
{
  var newstr = jstring.replace(/clid/g, "value"); 
  var newstr = newstr.replace(/clnm/g, "label"); 
  console.log('jsonrep',newstr);
  let resJSON = JSON.parse(newstr);
  var arr=Array.of(resJSON);
  
  this.classes=arr[0];
  console.log('classes',this.classes);
}

composefilterstaff(jstring)
{
  var newstr = jstring.replace(/emid/g, "value"); 
  var newstr = newstr.replace(/emnm/g, "label"); 
  console.log('jsonrep',newstr);
  let resJSON = JSON.parse(newstr);
  var arr=Array.of(resJSON);
  
  this.staffs=arr[0];
  console.log('staffs',this.staffs);
}


savestumentorallocation() {
  debugger
 
  this.mentservice.savestumentorallocation(this.fmodel,this.selectedItems,"allocate")
       .subscribe(resultArray => {
          console.log('ret-loop', resultArray);
//var cbclid=this.fmodel1,cbclid
          alert(resultArray.message);
          if(resultArray.status=='Success')
          {
            
         
         
            let localmodref=this.modalRef;
            localmodref.close();
          this.selectedItems=[];
          this.getstudentdata('sel_alloted', this.fmodel1);
         
          }
      }, error =>
          alert('error in connection')
      );
}

// onChangeclass(val)
// {

//   this.selclass=val;
//   this.getstudentdata('sel_alloted');
// }

// onChangestaff(val)
// {

//   this.selstaff=val;
//   this.getstudentdata('sel_alloted');
// }
}
